import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "leaders-page d-flex justify-center align-center py-10 flex-wrap" }
const _hoisted_2 = {
  key: 1,
  class: "text-error text-center w-full"
}

import { ref, onMounted } from 'vue';
import FounderCard from '@/components/DrUniversity/FounderCard/FounderCard.vue';
import { FounderCardProps } from '@/components/DrUniversity/FounderCard/FounderCard.model';
import { getAllFounders } from '@/services/drUniversity/founders/founder.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'DrUniversityFounders',
  setup(__props) {

const founders = ref<FounderCardProps[]>([]);
const loading = ref(true);
const error = ref<string | null>(null);

onMounted(async () => {
  try {
    founders.value = await getAllFounders();
  } catch (err: any) {
    error.value = err?.message || 'Failed to load founders.';
    console.error(err);
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(founders.value, (founder, index) => {
            return (_openBlock(), _createBlock(FounderCard, _mergeProps({ key: index }, { ref_for: true }, founder), null, 16))
          }), 128))
  ]))
}
}

})